import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import Framework from '../../components/framework';
import PageHeader from '../../components/framework/pages/page-header';
import LocationCounty from '../../components/location/county';
import MapSection from '../../components/location/map_section';
import Trans from '../../components/translation/trans';
import useQueryParameters from '../../hooks/use_query_parameters';
import useTranslation from '../../hooks/use_translation';

const Locations = ({ location }) => {
	const { queryParameters } = useQueryParameters();
	const { t } = useTranslation('receptions');

	return (
		<Framework
			description={t('meta_description')}
			location={location}
			tags={t('meta_keywords')}
			title={t('title')}
		>
			<div className="container" id="content">
				<PageHeader pageVariant="main_page" title={t('t1')} />
			</div>

			<MapSection include_locations={queryParameters?.location_id} />

			<div className="container mt-5">
				<LocationCounty />
			</div>
			<div className="container article-content mt-5">
				<Trans i18nKey="t4" t={t} />
			</div>
		</Framework>
	);
};

Locations.propTypes = {
	location: PropTypes.object.isRequired,
};

export default Locations;

export const query = graphql`
	query {
		locales: allLocale {
			...translationFields
		}
	}
`;
